// materialize-css 0.100 and react-materialize call a global jQuery. webpack
// used to create it as a side effect of running materialize as sloppy-mode
// CommonJS; as an ES module materialize throws instead. index.js imports this
// first: a module of its own, because an ES module cannot run code between
// its own imports.
import jQuery from 'jquery'

window.jQuery = window.$ = jQuery
